import ministryService from "../../services";
export default {
  namespaced: true,
  state: () => {
    return {
      ngoInfo: {
        estAccount: {},
        estMembers: [],
        governorates: [],
        classifications: [],
        estDocs: [],
      },
      loading: false,
      working: false,
    };
  },
  getters: {
    ngoInfo(state) {
      return state.ngoInfo;
    },
    loading(state) {
      return state.loading;
    },
    working(state) {
      return state.working;
    },
    events(state) {
      return {
        ngoInfo: state.ngoInfo.history,
        accountInfo: state.ngoInfo.estAccount.history,
        founders: state.ngoInfo.estMembers
          .map((el) => {
            if (el.history.length)
              return { name: el.full_name, history: el.history };
            else return null;
          })
          .filter((el) => el !== null),
      };
    },
  },
  mutations: {
    setData(state, payload) {
      state.ngoInfo = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setWorking(state, payload) {
      state.working = payload;
    },
  },
  actions: {
    async fetchNgoInfo({ commit }, id) {
      commit("setLoading", true);
      try {
        const data = await ministryService.fetchRequest(id);
        commit("setData", data.data);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },

    async validateInfo({ commit, dispatch }, payload) {
      commit("setWorking", true);
      try {
        if (payload.form.accepted) {
          await ministryService.acceptName({
            accepted: payload.form.accepted,
            id: payload.id,
          });
          delete payload.form.accepted;
        }
        await ministryService.validateInfo(payload.form);
        await dispatch("fetchNgoInfo", payload.id);
      } catch (err) {
      } finally {
        commit("setWorking", false);
      }
    },

    async sendFeedback({ commit, dispatch }, payload) {
      commit("setWorking", true);
      try {
        await ministryService.sendFeedback(payload.form);
        await dispatch("fetchNgoInfo", payload.id);
      } catch (err) {
      } finally {
        commit("setWorking", false);
      }
    },
    async changeStatus({ commit, dispatch }, id) {
      commit("setWorking", true);
      try {
        await ministryService.changeStatus(id);
        await dispatch("fetchNgoInfo", id);
      } catch (err) {
      } finally {
        commit("setWorking", false);
      }
    },
  },
};
